module.exports = __webpack_public_path__ + "static/media/Pedidos7.2859f488.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos7.png
// module id = 1785
// module chunks = 0